import styled from 'styled-components';
import colors from 'constants/colors';

/**
 * Height the greeting occupies while visible — the line plus the gap to whatever follows.
 * It is a fixed number so the collapse can animate without measuring anything.
 */
const BLOCK_HEIGHT = 52;
const BLOCK_HEIGHT_MOBILE = 44;

export const Wrapper = styled.div<{ isVisible: boolean }>`
  /* Held open before the greeting resolves so its arrival doesn't shove the page down. */
  height: ${BLOCK_HEIGHT}px;
  overflow: hidden;
  /* Fade first, then collapse, so the space closes on an already-empty line. */
  transition:
    opacity 380ms ease,
    height 380ms ease 260ms;

  ${({ isVisible }) => !isVisible && 'height: 0; opacity: 0;'}

  @media screen and (max-width: 992px) {
    height: ${({ isVisible }) => (isVisible ? `${BLOCK_HEIGHT_MOBILE}px` : '0')};
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const Line = styled.p<{ isReady: boolean }>`
  align-items: baseline;
  color: ${colors.main.black};
  display: flex;
  flex-wrap: wrap;
  /*
   * Deliberately subordinate to the featured program title, which is 48px DINNextW01-Condensed
   * at weight 300. Anything bolder or larger here out-shouts a lighter, bigger headline and
   * inverts the hierarchy — this is a salutation, not the page title.
   */
  font-size: 22px;
  font-weight: 400;
  gap: 0 8px;
  line-height: 28px;
  margin: 0;
  opacity: ${({ isReady }) => (isReady ? 1 : 0)};
  transition: opacity 300ms ease-out;

  @media screen and (max-width: 992px) {
    font-size: 19px;
    line-height: 24px;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const Phrase = styled.span`
  font-weight: 500;
`;

export const Name = styled.span`
  color: ${colors.main.grey};
`;

export const Roman = styled.span`
  color: ${colors.main.placeholdersAndDisabledBtnsText};
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.06em;
  line-height: 14px;
  text-transform: lowercase;
  white-space: nowrap;
`;
